<!--
 * @Author: your name
 * @Date: 2021-04-21 15:19:27
 * @LastEditTime: 2021-08-11 15:03:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\myOrder.vue
-->

<template>
  <div class="myorder">
    <van-tabs
      v-model="active"
      @click="tabClick"
      title-active-color="#f0240e"
      title-inactive-color="#999"
      class="tabs"
    >
      <van-tab v-for="(item,index) in tabList" :key="index" :title="item.title" :name="item.name"></van-tab>
    </van-tabs>
    <em></em>
    <van-list
      :immediate-check="true"
      class="container"
      v-if="orderList.length"
      v-model="loading"
      offset="300"
      direction="down"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <my-order-item
        class="order_item"
        v-for="(item,index) in orderList"
        :orderInfo="item"
        :key="index"
        @toOrderDetail="toOrderDetail"
        @orderPay="orderPay"
        @cancelOrder="cancelOrder"
      />
    </van-list>

    <div class="data-none" v-else>
      <img src="../assets/img/order-nodata.png" />
      <div class="order-sile">
        <div class="order-size">暂无订单</div>
        <div>您暂时还没有订单哦</div>
      </div>
    </div>
    <van-action-sheet v-model="show" title="选择支付方式 " @close="closeSheet">
      <div class="select_pay">
        <van-radio-group v-model="radio" @change="selectPayMh">
          <div class="flex just_beetw">
            <div class="flex alitem_center">
              <img :src="imgPath + 'yj_t_icon_zhifu@2x.png'" alt />
              <div>
                <p class="wx_pay">微信支付</p>
                <p class="aq_pay">微信安全支付</p>
              </div>
            </div>
            <van-radio name="1" icon-size="24px" checked-color="#ee0a24"></van-radio>
          </div>
          <div class="flex just_beetw mt_two">
            <div class="flex alitem_center">
              <img :src="imgPath + 'yj_t_kuaijiezhifu@2x.png'" alt />
              <div>
                <p class="wx_pay">快捷支付</p>
              </div>
            </div>
            <van-radio name="2" icon-size="24px" checked-color="#ee0a24"></van-radio>
          </div>
          <div class="flex just_beetw mt_two" v-if="bankInfo.bank_no">
            <p></p>
            <div>
              <span class="blank">{{bankInfo.bank_name}}</span>
              <span class="blank_sn">尾号{{bankInfo.bank_no}}</span>
            </div>
          </div>
        </van-radio-group>
      </div>
      <div class="content_pay" @click="goPay">去支付</div>
    </van-action-sheet>
  </div>
</template>

<script>
import myOrderItem from '@/views/myOrderItem'
import { Toast, Dialog } from 'vant'
import masterPath from '../../config.js'
document.body.style.backgroundColor = '#f7f8fa'
export default {
  name: 'myOrder',
  data() {
    return {
      // 订单数据对象
      orderList: [],
      loading: false,
      finished: false,
      error: false,
      active: '',
      // tab列表
      tabList: [
        { name: '-100', title: '全部' },
        { name: '0', title: '待付款' },
        { name: '1', title: '待发货' },
        { name: '2', title: '待收货' },
        { name: '3', title: '已完成' },
      ],
      // 请求订单数据对象
      orderParams: {
        order_status: -100,
        page: 1,
        limit: 10,
      },
      // 订单总数
      orderCount: '',
      // 用于上拉时加载数据的节流阀
      isLoading: false,
      // 支付节流
      isPaying: false,
      // 取消订单节流
      isCanceling: false,
      show: false,
      radio: '1',
      bankInfo: {},
      payUrl: '',
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    goPay() {
      window.location.href = `${
        masterPath.masterPay
      }/cashierDesk?${encodeURIComponent(
        this.payUrl
      )}&seler=${encodeURIComponent(this.radio == '2' ? 'rule' : 'pay')}`
    },
    //查看订单详情
    toOrderDetail(order_no, order_id, id) {
      this.$router.push({
        path: '/orderDetails',
        query: { order_no: order_no, order_id: order_id, id: id },
      })
    },
    closeSheet() {
      this.isPaying = false
      console.log('222')
    },
    // 支付功能&&收货
    async orderPay(
      order_id,
      order_status,
      order_no,
      order_money_dollar,
      shipping_money_dollar,
      parent_order_id,
      transfer_ids,
      order_type
    ) {
      console.log('-------', order_status)

      if (this.isPaying) return
      this.isPaying = true
      // 当前按钮点击收货
      if (order_status == 2) {
        console.log('待收货', order_id)
        try {
          // 调用收货接口
          this.http('ClientOrder.confirmDeliver', {
            order_detail_id: order_id,
          }).then((res) => {
            if (res.status == 200) {
              console.log(res)
              Toast('确认收货成功~')
              // this.$toast.fail('确认收货成功~')
              this.orderList = []
              this.orderParams.page = 1
              this.getOrderList()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } catch (err) {
          Toast('收货失败，请稍后重试~')
          // this.$toast.fail('收货失败，请稍后重试')
        } finally {
          this.isPaying = false
        }
      } else {
        // this.$router.push({
        //   path: '/ConfirmOrder',
        //   query: { order_id: order_id },
        // })
        this.show = true
        let params = {
          price: order_money_dollar,
          token: localStorage.getItem('token'),
          mechId: localStorage.getItem('mechId'),
          sn: order_no,
          transfer_ids: transfer_ids.length == 0 ? 0 : 1,
          type:
            order_type == 0
              ? 'buy'
              : order_type == 1
              ? 'package'
              : order_type == 2
              ? 'integral'
              : order_type == 3
              ? 'integral_group'
              : order_type == 4
              ? 'pick_up'
              : '',
        }
        let str = ''
        for (let i in params) {
          str += `${i}=${params[i]}&`
        }
        str = str.slice(0, str.length - 1)
        console.log(str)
        //当前按钮点击支付
        // this.payUrl = `${masterPath.masterPay}/cashierDesk?${str}`
        this.payUrl = str
      }
    },
    // 取消订单
    cancelOrder(order_id) {
      if (this.isCanceling) return
      this.isCanceling = true
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定要取消该订单吗?',
        })
        .then(async () => {
          try {
            console.log('取消订单' + order_id)
            let data = await this.http('ClientOrder.cancelOrder', { order_id })
            if (data.status !== 200) {
              return Toast('取消订单失败')
            }
            Toast('订单已取消')
            // 重新获取订单数据
            this.orderList = []
            this.orderParams.page = 1
            this.getOrderList()
          } catch (err) {
            Toast('取消订单失败')
          } finally {
            this.isCanceling = false
          }
        })
        .catch(() => {
          // this.$toast.success('操作已取消')
          this.isCanceling = false
        })
    },
    // 获取订单列表
    async getOrderList() {
      // 开启节流阀
      this.isLoading = true
      let data = await this.http('ClientOrder.getOrderList', this.orderParams)
      data.content.list.map((i) => {
        i.total = 0
        i.child_list.map((item) => {
          i.total += item.num
        })
      })
      // 追加订单数据
      this.loading = false
      this.orderList = this.orderList.concat(data.content.list)
      this.finished = this.orderList.length == data.content.count
      console.log(this.orderList.length)
    },
    // tab栏的点击事件
    tabClick(name) {
      let flag = false
      if (flag) return
      this.orderList = []
      this.orderParams.page = 1
      this.orderParams['order_status'] = Number(name)
      this.finished = false
      this.getOrderList()
      flag = false
    },
    // 上拉加载钩子
    onLoad() {
      this.orderParams.page++
      this.getOrderList()
    },
    // 选择支付方式
    selectPayMh(event) {
      console.log(event)
      if (event == 2) {
        this.getAuthInfo()
      }
    },
    //查询是否认证
    getAuthInfo() {
      this.http('MemberAuth.getAuthInfo', {}).then((res) => {
        console.log(res)
        if (res.content.auth_data.is_identity_checked == 1) {
          this.$router.push({
            path: '/realName',
            query: {
              real_name_fee: res.content.auth_data.real_name_fee_dollar,
              is_identity_checked: res.content.auth_data.is_identity_checked,
              is_acct_checked: res.content.auth_data.is_acct_checked,
              user: 'rule',
            },
          })
        } else {
          this.getUserBank(res.content.auth_data)
        }
      })
    },
    // 获取电子协议url
    getSignContract() {
      this.http('MemberAuth.signContract', {}).then((res) => {
        if (res.status == 200) {
          console.log(res)
          window.location.href = res.content.url
        }
      })
    },
    //查询是否绑定银行卡
    getUserBank(authInfo) {
      this.http('Client.getUserBank', { type: 2 }).then((res) => {
        if (res.content.length == 0) {
          Dialog.confirm({
            title: '温馨提示',
            message: '您还未绑定银行卡，请前去绑卡',
          })
            .then(() => {
              console.log('222')
              this.$router.replace({
                path: '/bindingBank',
                query: {
                  identity_card_no: authInfo.identity_card_no,
                  name: authInfo.name,
                  user: 'rule',
                },
              })
            })
            .catch(() => {
              this.radio = '1'
            })
        } else {
          this.bankInfo = res.content
          this.bankInfo.bank_no = res.content.bank_card_no.substring(
            res.content.bank_card_no.length - 4
          )
        }
      })
    },
  },
  created() {
    this.active = String(this.$store.state.orderStatus)
  },
  activated() {
    this.isPaying = false
    // 使用保存的订单列表滚动位置
    const scrollTop = this.$route.meta.scrollTop
    const $container = document.querySelector('.container')
    if (scrollTop && $container) {
      $container.scrollTop = scrollTop
    }
    this.orderList = []
    this.orderParams.page = 1
    this.orderParams['order_status'] = this.active = String(
      this.$store.state.orderStatus
    )
    this.getOrderList()
  },
  components: {
    myOrderItem,
  },
  watch: {
    active(val) {
      console.log(val)
      this.$store.commit('orderStatusFg', val)
    },
  },
}
</script>

<style lang="scss" scoped>
$tabHeight: 88px;
.myorder {
  position: fixed;
  bottom: 0;
  margin-left: 20px;
  .tabs {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: $tabHeight;
    z-index: 999;
  }
  .container {
    margin-top: $tabHeight;
    padding-top: 5px;
    height: calc(100vh - #{$tabHeight});
    overflow-y: auto;
  }
}

.data-none {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background: #fff;
  img {
    width: 320px;
    height: 320px;
    display: block;
    margin: 150px auto;
  }
  .order-sile {
    text-align: center;
    font-weight: 400;
    color: #969799;
    line-height: 28px;
    text-align: center;
    .order-size {
      font-weight: 500;
      color: #666666;
      line-height: 28px;
      margin: 40px 0 32px;
    }
  }
}
// 选择支付方式
.select_pay {
  width: 710px;
  background: rgba(255, 255, 255, 1);
  margin: 20px auto 0;
  border-radius: 14px;
  padding: 20px 24px;
  box-sizing: border-box;
  .just_beetw {
    justify-content: space-between;
  }
  .alitem_center {
    align-items: center;
    div {
      margin-left: 24px;
    }
  }
  .mt_two {
    margin-top: 38px;
  }
  img {
    width: 72px;
    height: 72px;
  }
  .wx_pay {
    font-size: 28px;
    color: #323233;
  }
  .aq_pay {
    font-size: 24px;
    color: #969799;
  }
  .blank {
    font-size: 28px;
    color: #323233;
    margin-right: 8px;
  }
  .blank_sn {
    font-size: 24px;
    color: #969799;
  }
}
.content_pay {
  text-align: center;
  padding: 35px 0;
}
</style>
